import { StyleSheet, type ViewStyle } from 'react-native';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const paletteStyles = StyleSheet.create<AlertContainerPaletteStyles>({
  info: {
    backgroundColor: theme.colors.OPACITY.KALE.LIGHTEST,
  },
  success: {
    backgroundColor: theme.colors.CUCUMBER,
  },
  caution: {
    backgroundColor: theme.colors.PEACH,
  },
});

export const paletteBorderStyles = StyleSheet.create<AlertContainerPaletteStyles>({
  info: {
    borderWidth: 1,
    borderColor: theme.colors.OPACITY.KALE.LIGHTER,
  },
  success: {
    borderWidth: 1,
    borderColor: theme.colors.CUCUMBER_HOVER,
  },
  caution: {
    borderWidth: 1,
    borderColor: theme.colors.BLUSH,
  },
});

// ─────────────────────────────────────────────────────────────────────────────

export type AlertContainerPalette = 'success' | 'info' | 'caution';

type AlertContainerPaletteStyles = Record<AlertContainerPalette, ViewStyle>;
